/**
 * [Gurumi 이미지 업로드]
 * 역할: yesmoney editor-image-upload 유틸 포팅
 * 작성/수정일: 2026-07-29
 */
export const EDITOR_IMAGE_MAX_WIDTH = 720;

export function loadImageFileDimensions(file) {
  return new Promise((resolve, reject) => {
    const previewUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(previewUrl);
      resolve({ width: Math.max(1, img.naturalWidth), height: Math.max(1, img.naturalHeight) });
    };
    img.onerror = () => {
      URL.revokeObjectURL(previewUrl);
      reject(new Error('이미지를 읽을 수 없습니다.'));
    };
    img.src = previewUrl;
  });
}

export function computeEditorImageDisplaySize(naturalWidth, naturalHeight, maxWidth = EDITOR_IMAGE_MAX_WIDTH) {
  const safeWidth = Math.max(1, naturalWidth);
  const width = Math.min(safeWidth, maxWidth);
  const height = Math.max(1, Math.round(naturalHeight * (width / safeWidth)));
  return { width, height };
}

export function findEditorImagePosBySrc(editor, src) {
  let found = null;
  editor.state.doc.descendants((node, pos) => {
    if (node.type.name !== 'image') return;
    if (String(node.attrs.src ?? '') === src) {
      found = pos;
      return false;
    }
  });
  return found;
}

export function replaceEditorImageAtPos(editor, pos, attrs) {
  const node = editor.state.doc.nodeAt(pos);
  if (!node || node.type.name !== 'image') return false;
  editor.view.dispatch(editor.state.tr.setNodeMarkup(pos, undefined, { ...node.attrs, ...attrs }));
  return true;
}

export function resolveEditorImageUrl(src) {
  const value = String(src ?? '').trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith('//')) return `${window.location.protocol}${value}`;
  if (value.startsWith('/')) return `${window.location.origin}${value}`;
  return value;
}
